import React, { useContext } from "react"
import { Link } from "gatsby"
import { UserContext } from "../../utils/usermanagement"
import logo from '../../images/EE-logo.png'

import "./Footer.scss"

const Footer = ({ pageTitle }) => {
	const userStateData = useContext(UserContext);

	const isPartiallyActive = ({ isPartiallyCurrent }) => {
		return isPartiallyCurrent ? { className: "active" } : {}
	}
	
	const dataLayerClickHandler = (element) => {
		let linkUrl = element.currentTarget.href,
		  clickText = element.currentTarget.innerText,
		  rollType = "anonymous",
		  loginStatus = "logged-out",
		  linkDomain = process.env.GATSBY_APP_DOMAIN;
	
		if (
		  userStateData &&
		  userStateData[0] &&
		  userStateData[0]?.cognito_user?.username
		) {
		  rollType = "parent";
		  loginStatus = "logged-in";
		}
	
		let analyticsObj = {
		  event: "Navigation_interaction",
		  loginStatus: loginStatus,
		  actionType: "Footer Link Click",
		  clickText:
			element.currentTarget.parentElement?.className === "logo"
			  ? "EEPhoneSmart Logo"
			  : clickText,
		  linkType: linkUrl.indexOf(linkDomain) === -1 ? "external" : "internal",
		  linkUrl: linkUrl,
		  moduleName: "Navigation",
		  pageName: pageTitle,
		  inPageLocation: "bottom",
		  userType: rollType,
		};
	
		window.dataLayer.push(analyticsObj);
	};

	return (

		<footer className="site-footer">
			<div className="container">
				<div className="row">
					<div className="footer-wrapper">
						<div className="logo">
							<Link to={`/`} onClick={(e) => dataLayerClickHandler(e)}>
								<img src={logo} alt="EE PhoneSmart" />
							</Link>
						</div>						
						<div>
							<ul className="footer-links">
								<li>
									<a href="mailto:phonesmart@ee.co.uk" onClick={(e) => dataLayerClickHandler(e)}>
										Report an issue
									</a>
								</li>
								<li>
									<Link to={`/about/`} onClick={(e) => dataLayerClickHandler(e)} getProps={isPartiallyActive}>
										About EE PhoneSmart
									</Link>
								</li>
							</ul>
						</div>
						<div>
							<ul className="footer-links">
								<li>
									<a href={`/cookie/`} target="_blank" rel={"noreferrer"} onClick={(e) => dataLayerClickHandler(e)}>
										Cookie policy
									</a>
								</li>
								<li>
									<a href={`/terms/`}  target="_blank" rel={"noreferrer"} onClick={(e) => dataLayerClickHandler(e)}>
										Terms and conditions
									</a>
								</li>
							</ul>
						</div>
						<div>
							<ul className="footer-links">
								<li>
									<a href="https://ee.co.uk/eeprivacycentre" target="_blank" rel="noreferrer" onClick={(e) => dataLayerClickHandler(e)}>
										Privacy policy
									</a>
								</li>
								<li>
									<a href="https://ee.co.uk" target="_blank" rel="noreferrer" onClick={(e) => dataLayerClickHandler(e)}>
										EE.co.uk
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="copyright">© 2021 EE Limited</div>
				</div>
			</div>

		</footer>
	)
}

export default Footer
